import React from "react";
import { FaChartLine, FaShieldAlt, FaFileContract, FaCreditCard, FaCompass, FaDesktop, FaBell, FaMoneyBillWave, FaCogs, FaTachometerAlt } from "react-icons/fa";

function AdvancedTOptions() {
  return (
    <>
      <div
        className="brand-style-two-area default-padding bg-theme text-light bg-cover"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-15.jpg)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Key Features of Our White Label DEX Exchange:
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="brand-style-two-items">
                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Advanced Trading Options</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaChartLine size={48} />
                    </div>
                  </div>
                </div>
                <div className="brand-style-two-item wow fadeInUp">
                  <h5>State-of-the-art Security Mechanisms</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                       <FaShieldAlt size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Impenetrable Smart Contracts</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaFileContract size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Support Multiple Payment Gateways</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaCreditCard size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Easy-to-navigate Platform</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaCompass size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Simple Yet Intuitive User Interface</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaDesktop size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Real-time Alerts and Notifications</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaBell size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Multi-Crypto and Fiat Support</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaMoneyBillWave size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>100% Customizable and Scalable Platform</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaCogs size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Robust Admin and User Dashboard</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaTachometerAlt size={48} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdvancedTOptions;
